import { AccountModuleAccountResetProgressDto } from '@tfs/tool-library-library-api';

export { AccountModuleAccountResetProgressDto as AccountResetProgress };

export function isResetRunning(
  progress: AccountModuleAccountResetProgressDto | null | undefined
): boolean {
  return (
    progress?.status === 'Queued' ||
    progress?.status === 'InProgress' ||
    progress?.status === 'Finalizing'
  );
}
